// Product Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get productList from backend then update productList in vuex store ***** //
export const updateProductsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('products_index', { params: params })
    commit('updateProductsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Product from backend ***** //
export const fetchProductInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`products_show/${payload}`)
    commit('fetchProductInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Product  ***** //
export const addProduct = async (ignored, payload = null) => {
  try {
    await Axios.post('products_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Product  info ***** //
export const updateProductInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`products_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Product  ***** //
export const deleteProduct = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`products_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullSaleProductsList = async ({ commit }) => {
  let productListSalesList = []

  try {
    const result = await Axios.get('products_list_sell')
    result.data.data.forEach(productListSale => {
      productListSalesList.push({
        value: productListSale.product_id,
        text: productListSale.product_name_with_quantity,
        sale_price: productListSale.sale_price,
        quantity: productListSale.quantity,
        collections: productListSale.collections
      })
    })
    commit('setFullSaleProductsList', productListSalesList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

export const setFullPurchaseProductsList = async ({ commit }) => {
  let purchaseProductsList = []

  try {
    const result = await Axios.get('products_list_purchase')
    result.data.data.forEach(purchaseProduct => {
      purchaseProductsList.push({
        value: purchaseProduct.product_id,
        text: purchaseProduct.product_name,
        collections: purchaseProduct.collections
      })
    })
    commit('setFullPurchaseProductsList', purchaseProductsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

export const setFullProductsList = async ({ commit }) => {
  let fullProductsList = []

  try {
    const result = await Axios.get('products_list')
    result.data.data.forEach(product => {
      fullProductsList.push({
        value: product.product_id,
        text: product.product_name,
        sale_price: product.sale_price,
        collections: product.collections
      })
    })
    commit('setFullProductsList', fullProductsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
